module.exports = "<md-toolbar class=header md-whiteframe=4 ng-show=c.user.fullname> <div class=md-toolbar-tools> <md-button tabindex=-1 class=\"md-icon-button no-left-margin white-hoverable-button\" ng-click=c.toggleLeft()> <md-icon>menu</md-icon> </md-button> <span class=header-title tabindex=-1 ng-click=c.goHome()>LOS</span> <span flex></span> <span>{{c.user.fullname}}</span> <md-button tabindex=-1 class=\"md-icon-button white-hoverable-button\" ng-click=c.logout() ng-show=c.user.fullname> <md-tooltip>Logg ut</md-tooltip> <md-icon>exit_to_app</md-icon> </md-button> </div> </md-toolbar>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/main/header/header.html
 ** module id = 482
 ** module chunks = 0
 **/